import * as React from 'react'
import styled from 'styled-components'
import Icon3D from 'assets/icon-3d.svg'
import Button from 'theme/atoms/Button'
import theme from 'theme'
import { useDisplayVariant } from 'modules/productDetail'
import * as evt from './events'
import useTranslations from 'hooks/useTranslations'
import config from 'config'

type Props = {
  'data-cy-state': string
}

export default function Open3DView(props: Props) {
  const t = useTranslations<'templates-PDP'>()
  const variant = useDisplayVariant()
  const sku = variant.data.sku
  const url3D = `https://ui.pcon-solutions.com/#GATEKEEPER_ID=67ab3a4c439d8&cep=lus%3A0%2Ceo%3A%40Lusini%24default&moc=LUS&ban=${sku}&fso=true&lang=${config.features.cmpConsilius3dViewer?.language || 'en'}`
  return (
    <Wrapper className="Open3DView" data-cy-state={props['data-cy-state']}>
      <Button
        className="link-button-3d"
        variation="cart_disabled"
        data-cy-handle="open-3D-model"
        onClick={() => evt.pdp3DOpen(variant.data.sku, variant.data.title)}
        to={url3D}
      >
        <div className="btn-content-3d">
          <Icon3D />
          {t('open_3d_view')}
        </div>
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing('m')};

  > .link-button-3d {
    background-color: ${theme.colors.white};
    padding: 0.4375rem 1.875rem;
    height: 2.25rem;
    @media (min-width: ${theme.ms.LG}px) {
      height: 2.625rem;
    }

    > .btn-content-3d {
      display: flex;
      ${theme._ty([16, 0, 16], theme.font, '700')}
      color: ${theme.colors.shade.b2};
      align-items: center;
      justify-content: center;

      > svg {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.3125rem;
        > g > path {
          fill: ${theme.colors.shade.b2};
        }
      }
    }
  }
`
